import React from 'react'

const RequieredInputs = ({ invert = true }) => {
  const styles = {
    color: '#fb7a00',
    fontWeight: '600',
    filter: invert ? 'invert(1)' : undefined,
  }

  return <span style={styles}>*</span>
}
export default RequieredInputs